export enum Language {
  english = 'en_US',
  spanish = 'es_ES',
  japanese = 'jp_JP'
}
